// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q774OWwLXloLf6r9 {
  cursor: not-allowed;
  opacity: 0.55;
}
.gBRdnsRCE4KvZZvB.q774OWwLXloLf6r9:hover {
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/intl/components/Service/index.modules.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;AACF;AAEA;EACE,gBAAA;AAAF","sourcesContent":[".disabledCard {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.complaints.disabledCard:hover {\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabledCard": `q774OWwLXloLf6r9`,
	"complaints": `gBRdnsRCE4KvZZvB`
};
export default ___CSS_LOADER_EXPORT___;
